import { tv } from '@change/ds-utils';

export const shareableAssetStyles = tv({
	base: 'group relative inline-block w-52 shrink-0 snap-start lg:w-[calc(25%-16px)]',
	variants: {
		type: {
			post: 'aspect-[4/5]',
			story: 'aspect-[9/16]',
			legacy: 'aspect-square',
		},
		isLast: {
			true: 'mr-4',
		},
	},
});

export const downloadButtonStyle = tv({
	base: [
		'flex items-center justify-center',
		'absolute inset-0 bg-black/30 opacity-0 transition-opacity',
		'transition-opacity lg:group-focus-within:opacity-100 lg:group-hover:opacity-100',
	],
	variants: {
		type: {
			post: 'aspect-[4/5]',
			story: 'aspect-[9/16]',
			legacy: 'aspect-square',
		},
	},
});

export const shareableImageStyle = tv({
	base: 'rounded-lg lg:h-full',
	variants: {
		type: {
			post: 'aspect-[4/5]',
			story: 'aspect-[9/16]',
			legacy: 'aspect-square',
		},
	},
});
